module.exports = __webpack_public_path__ + "static/media/image11.49d14d91.jpeg";